<template>
  <div>
    <jd-form
      :form-info="getBirthInfoFormInfo"
      @search="searchBirthInfo"
      class="mt16 mb16"
    />
    <div class="mb12 flex-spc-x">
      <jd-button @click="addCrowd" :disabled="!birthInfoList.length"
        >按查询结果生成人群</jd-button
      >
      <jd-button @click="exportBirthFn" type="text" v-preventReClick
        >导出</jd-button
      >
    </div>
    <!-- 表格 -->
    <jd-table
      :tableData="birthInfoList"
      :pageInfo="{
        pageNum: birthInfoForm.current,
        pageSize: birthInfoForm.size,
        total: birthInfoTotal,
      }"
      @handlePage="handlePage"
      :loading="loading"
    >
      <el-table-column prop="chaosPin" label="用户pin（加密）" width="150">
      </el-table-column>
      <el-table-column prop="memberNick" label="用户昵称"> </el-table-column>
      <el-table-column prop="activityName" label="活动名称"> </el-table-column>
      <el-table-column prop="birthDay" label="登记生日">
        <template slot-scope="scope">
          <span>{{ scope.row.birthDay ? scope.row.birthDay : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="createTime" label="登记时间">
        <template slot-scope="scope">
          <span>{{ scope.row.createTime ? scope.row.createTime : "-" }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="sellerLinkName" label="投放渠道"></el-table-column>
    </jd-table>
    <!-- 登记生日信息导出 -->
    <generate
      :control="isShowExport"
      v-if="isShowExport"
      @transData="(val) => (isShowExport = val)"
      @transData1="getphoneFn"
    ></generate>
  </div>
</template>
<script>
import { getBirthdayInfo } from "@/api/jhk/paradiseAndTaskCommonController";
import { exportBirth } from "@/api/jhk/integralCenter/PointActivityAnalyticController";
import generate from "@/components/generate_report.vue";
export default {
  name: "birthInfo",
  components: {
    generate
  },
  props: {
    birthInfoFormList: {
      type: Array,
      default: () => [{}],
    },
    activityId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      isShowExport: false,
      loading: false,
      birthInfoTotal: 0,
      birthInfoList: [],
      birthInfoForm: {
        sellerLinkId: "",
        customerPin: "",
        memberNick: "",
        registerStartTime: "",
        registerEndTime: "",
        birthStartTime: "",
        birthEndTime: "",
        size: 10,
        current: 1
      },
    };
  },
  computed: {
    getBirthInfoFormInfo: {
      get() {
        return this.birthInfoFormList;
      },
      set(val) {
        this.$emit("update:birthInfoFormList", val);
      },
    },
  },
  watch: {},
  mounted() {
    this.getBirthInfoDetail();
  },
  methods: {
    // 登记生日信息导出
    getphoneFn(exportRemark) {
      let params = {
        activityId: this.activityId,
        ...this.birthInfoForm,
        current: this.birthInfoForm.current,
        size: this.birthInfoForm.size,
        exportRemark: exportRemark,
      };
      exportBirth(params).then((res) => {
        if (res.code == 1) {
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addCrowd() {
      this.$emit("addCrowd", 52);
    },
    exportBirthFn() {
      this.isShowExport = true;
    },
    handlePage(page) {
      this.birthInfoForm.current = page.pageNum;
      this.birthInfoForm.size = page.pageSize;
      this.getBirthInfoDetail();
    },
    getBirthInfoDetail() {
      this.loading = true;
      getBirthdayInfo({ ...this.birthInfoForm, activityId: this.activityId })
        .then((res) => {
          this.loading = false;
          if (res.code == 1) {
            this.birthInfoList = res.data.records || [];
            this.birthInfoTotal = +res.data.total;
          }
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    searchBirthInfo(val) {
      this.birthInfoForm.customerPin = val.customerPin ? val.customerPin : "";
      this.birthInfoForm.memberNick = val.memberNick ? val.memberNick : "";
      this.birthInfoForm.registerStartTime = val.registerStartTime
        ? val.registerStartTime
        : "";
      this.birthInfoForm.registerEndTime = val.registerEndTime
        ? val.registerEndTime
        : "";
      this.birthInfoForm.birthStartTime = val.birthStartTime
        ? val.birthStartTime
        : "";
      this.birthInfoForm.birthEndTime = val.birthEndTime
        ? val.birthEndTime
        : "";
      this.birthInfoForm.sellerLinkId = val.sellerLinkId
        ? val.sellerLinkId
        : "";
      this.birthInfoForm.size = 10;
      this.birthInfoForm.current = 1;
      this.getBirthInfoDetail();
    },
  },
};
</script>
<style lang="scss" scoped></style>
